const initRegistrationStandsSelection = () => {
  if (typeof window.makeStandSelectable !== "function") return

  document.querySelectorAll("#stands-layout .stand-div[data-stand-id]").forEach((stand) => {
    if (stand.dataset.standSelectionBound === "1") return
    stand.dataset.standSelectionBound = "1"
    window.makeStandSelectable(stand)
  })
}

const initSelectStands = () => {
  window.initRegistrationStandsSelection = initRegistrationStandsSelection
  window.makeStandSelectable = (stand) => {
    stand.addEventListener("click", (e) => {
      var standId = stand.dataset.standId;
      document.querySelector(`#selected_stands_stands_ids option[value='${standId}']`).setAttribute("selected", "selected");
      stand.style.border = "#C74827 3px solid";
      makeStandUnselectable(stand);
    });
  };

  window.makeStandUnselectable = (stand) => {
    stand.addEventListener("click", (e) => {
      var standId = stand.dataset.standId;
      document.querySelector(`#selected_stands_stands_ids option[value='${standId}']`).removeAttribute("selected");
      stand.style.border = "solid 2px #454B57";
      makeStandSelectable(stand);
    });
  };

  window.scrollToExhibitorStandSelection = () => {
    const target = document.getElementById("exhibitor-stand-selected-heading")
    if (!target) {
      window.scrollTo(0, 0)
      return
    }
    const offset = 100
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset
    window.scrollTo(0, Math.max(0, top))
  }
};

export { initSelectStands, initRegistrationStandsSelection };
